module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-presa-de-stampile.602a4090.jpg";